import { FormProvider, useForm } from 'react-hook-form';
import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import { FormValues } from '../types';
import { FormContext } from '../lib/helpers/context';
import { useAppSelector } from 'shared/lib/store';
import { selectTableUsedBeforeFlag } from 'entities/hallmap';

interface ClientFormProviderProps {
	children: ReactNode;
}

export const ClientFormProvider: FC<ClientFormProviderProps> = ({
	children,
}) => {
	const formMethods = useForm<FormValues>({
		defaultValues: {
			phone: '',
			name: '',
			notes: '',
		},
	});

	const tableUsedBefore = useAppSelector(selectTableUsedBeforeFlag);
	const [bookingBtnIsActive, setActiveSaveBookingBtn] = useState(true);

	const activeBookingBtn = useCallback(() => {
		setActiveSaveBookingBtn(false);
	}, []);

	useEffect(() => {
		if (tableUsedBefore) {
			activeBookingBtn();
		}
	}, [tableUsedBefore, activeBookingBtn]);

	return (
		<FormContext.Provider
			value={{
				formMethods,
				activeBookingBtn,
				bookingBtnIsActive,
			}}
		>
			<FormProvider {...formMethods}>{children}</FormProvider>
		</FormContext.Provider>
	);
};
